import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  priceTitle: {
    padding: "0.8em 0",
    marginTop: "0.8em",
  },
  priceText: {
    textAlign: "center",
    marginBottom: 70,
  },
}));

export default function Title({ title, description }) {
  const classes = useStyles();
  return (
    <Box textAlign="center">
      <Typography className={classes.priceTitle} variant="h1" color="primary">
        {title}
      </Typography>
      <Typography color="textSecondary" className={classes.priceText}>
        {description}
      </Typography>
    </Box>
  );
}
